import vue from "vue";
export const chatbotResponse = async (payload) =>
  await vue.axios.post(
    "https://chatbot.fastforge.ai/webhooks/rest/webhook",
    payload
  );
